import { styled } from '@material-ui/core/styles';
import { Button, Container, Typography, Box, Stack } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Icon } from '@iconify/react';
import AuthLayout from '../layouts/AuthLayout';
import Page from '../components/Page';
import React, { useState, useEffect, useContext } from 'react';
import cornerupleft from '@iconify/icons-eva/corner-up-left-fill';
import './index.css';
import packageJson from "../../package.json";
import functions from "../constants/serverFunctions";
import axios from "axios";
import { addItem, getItem } from '../components/services/LocaleStorage';


// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(10, 0),

}));


// ----------------------------------------------------------------------


export default function Version() {

  const [versionBack, setVersionBack] = useState([]);

  useEffect(() => {

    const token = getItem('token-assembleia-api');
    axios.get(functions.version.VERSION, { headers: { "Authorization": `${token}` } })
      .then((res) => {
        setVersionBack(res.data.version)
      })
      .catch((err) => { });
  }, []);






  return (

    <RootStyle title="Create-Proposta | ASSEMBLEIACOOP">
      <AuthLayout>
        <Button
          className="btn-cinza"
          component={RouterLink}
          to="instituicao"
        >
          <Icon icon={cornerupleft} />&nbsp; Inicio
        </Button>
      </AuthLayout>




      <Container maxWidth="sm" className='conteudo-geral'>
        <ContentStyle style={{ maxWidth: '680px' }}>
          <Stack className='titulo-geral' >
            <Typography variant="h4" gutterBottom>
              Versão Backend do Sistema
            </Typography>
            <Typography variant='p'>
              {versionBack}
            </Typography>
            <br />
          </Stack>
      
      
          <Stack className='titulo-geral' >
            <Typography variant="h4" gutterBottom>
              Versão Frontend do Sistema
            </Typography>
            <Typography variant='p'>
              {packageJson.version}
            </Typography>
            <br />
          </Stack>
        </ContentStyle>
      </Container>




    </RootStyle>


  )


}